/**
 * Selects an image from the fallback image list based on the received base string.
 * If the base string does not change, it returns the same image.
 * @param {string[]} imageFallbackList -  The list of the image urls
 * @param {string} baseString - The string on which the hash (selection) is based.
 * @return {string} - The selected image url
 */
export const getFallbackImage = (
	imageFallbackList: string[],
	baseString: string
): string => {
	if (imageFallbackList.length === 0) return '';
	if (imageFallbackList.length === 1) return imageFallbackList[0];

	const hashFromBaseString = getNumber(baseString);
	const index = hashFromBaseString % imageFallbackList.length;
	return imageFallbackList[index];
};

const getNumber = (input: string): number => {
	let number = 0;
	if (!input || input.length === 0) return number;
	for (let i = 0; i < input.length; i++) {
		number += input.charCodeAt(i);
	}
	return number;
};
